<script setup lang="ts">
  // Vue core imports
  import { ref } from 'vue'
  // External library imports
  import type { PropType } from 'vue'

  import { HLForm } from '@platform-ui/highrise'

  // Type imports

  // Props definitions
  const props = defineProps({
    model: {
      type: Object,
      required: true,
    },
    rules: {
      type: Object,
      required: false,
      default: undefined,
    },
    labelAlign: {
      type: String as PropType<'left' | 'right' | undefined>,
      required: false,
      default: undefined,
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      required: false,
      default: 'md',
    },
    showFeedback: {
      type: Boolean,
      required: false,
      default: true,
    },
    showLabel: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRequireMark: {
      type: Boolean,
      required: false,
      default: true,
    },
    labelWidth: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    labelPlacement: {
      type: String as PropType<'left' | 'top'>,
      required: false,
      default: 'top',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  })

  // Refs
  const formRef = ref(null)

  // Expose form methods to parent components
  const getForm = () => {
    return formRef.value?.getForm() || null
  }

  const validate = (callback?: (errors?: any[]) => void) => {
    if (formRef.value) {
      return formRef.value.validate(callback)
    }
    return Promise.resolve()
  }

  const restoreValidation = () => {
    if (formRef.value) {
      formRef.value.restoreValidation()
    }
  }

  // Expose methods to parent components
  defineExpose({
    getForm,
    validate,
    restoreValidation,
    formRef,
  })

  defineOptions({ name: 'CPForm', inheritAttrs: false })
</script>

<template>
  <HLForm
    ref="formRef"
    v-bind="$attrs"
    :model="props.model"
    :rules="props.rules"
    :label-align="props.labelAlign"
    :size="props.size"
    :show-feedback="props.showFeedback"
    :show-label="props.showLabel"
    :show-require-mark="props.showRequireMark"
    :label-width="props.labelWidth"
    :label-placement="props.labelPlacement"
    :disabled="props.disabled"
    :input-group-size="props.size"
  >
    <slot />
  </HLForm>
</template>
